import {connect} from 'react-redux';
import ShowAllTournamentsCheckbox from './ShowAllTournamentsCheckbox.jsx';
import {handleShowAllTournamentsChange} from '../tournamentList/actions';

const mapStateToProps = state => ({
  showAllTournaments: state.tournament.tournamentList.showAllTournaments
});

const mapDispatchToProps = dispatch => ({
  onShowAllTournamentChange: checked => dispatch(handleShowAllTournamentsChange(checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowAllTournamentsCheckbox);



// WEBPACK FOOTER //
// ./src/features/tournament/home/ShowAllTournamentsCheckboxContainer.jsx